import { initialState } from './state';

export function setPatientId(state, patientId) {
  Object.assign(state, { patientId });
}

export function setVersion(state, version) {
  Object.assign(state, { version });
}

export function setCurrentAmountReceivedHypertensionDrugs(state, currentAmountReceivedHypertensionDrugs) {
  Object.assign(state, { currentAmountReceivedHypertensionDrugs });
}

export function setMeanBloodPressureAboveGoal(state, meanBloodPressureAboveGoal) {
  Object.assign(state, { meanBloodPressureAboveGoal });
}

export function setBodyWeight(state, bodyWeight) {
  Object.assign(state, { bodyWeight });
}

export function setPulseRate(state, pulseRate) {
  Object.assign(state, { pulseRate });
}

export function setLDL(state, LDL) {
  Object.assign(state, { LDL });
}
export function setLDLInPreferredUnit(state, LDLInPreferredUnit) {
  Object.assign(state, { LDLInPreferredUnit });
}


export function setEGFR(state, eGFR) {
  Object.assign(state, { eGFR });
}

export function setDistanceWalked(state, distanceWalked) {
  Object.assign(state, { distanceWalked });
}

export function setBloodPressureSystolic(state, bloodPressureSystolic) {
  Object.assign(state, { bloodPressureSystolic });
}

export function setBloodPressureDiastolic(state, bloodPressureDiastolic) {
  Object.assign(state, { bloodPressureDiastolic });
}

export function setIsWalkingTestPerformed(state, isWalkingTestPerformed) {
  Object.assign(state, { isWalkingTestPerformed });
}

export function setNotPerformedReasonGroup(state, notPerformedReasonGroup) {
  Object.assign(state, { notPerformedReasonGroup });
}

export function setNotPerformedReason(state, notPerformedReason) {
  Object.assign(state, { notPerformedReason });
}

export function setPerceivedExertion(state, perceivedExertion) {
  Object.assign(state, { perceivedExertion });
}

export function reset(state) {
  const {version, patientId} = state;
  Object.assign(state, initialState());
  state.version = version;
  state.patientId = patientId;
}

export function switchToValidationMode(state) {
  Object.assign(state, { isValidationMode: true });
}

export function switchToNormalMode(state) {
  Object.assign(state, { isValidationMode: false });
}
